import React, { ReactNode, useEffect, useState } from "react";
import styles from "./reportsCollectionWrapper.module.scss";
import ReportElementWrapper from "../reportElementWrapper/ReportElementWrapper";

interface ReportsCollectionWrapperProps {
    reports: any[];
    renderReportElement: (report: any) => ReactNode;
    reportElementTitle: (report: any) => string | undefined;
    reportElementText: (report: any) => string | undefined;
    isCompactView?: boolean;
}

const ReportsCollectionWrapper: React.FC<ReportsCollectionWrapperProps> = (props: ReportsCollectionWrapperProps) => {
    const renderElementWrapper = (report: any, indexKey: number) => {
        return (
            <ReportElementWrapper
                report={report}
                additionalClassName={props.isCompactView ? styles.reportCompactElement : styles.reportElement}
                reportElementTitle={props.reportElementTitle}
                reportElementText={props.reportElementText}
                renderReportElement={props.renderReportElement}
                key={`ReportElementWrapper_${indexKey}`}
            />
        );
    };

    return (
        <div className={styles.report}>{props.reports.map((report, index) => renderElementWrapper(report, index))}</div>
    );
};

export default ReportsCollectionWrapper;
